import { Layout, MenuProps, SiderProps as _SiderProps } from 'antd'
import useGlobalModal from 'shared/global-modal/libs/useGlobalModal'
import { Icon } from 'shared/iconpack'

import { useMemo, useState } from 'react'

import { NavLink, useLocation, useNavigate } from 'react-router-dom'

import { items } from 'routes/Dashboard/ui/components/Sider/profileDropdownItems'

import ConfirmLogout from 'modules/Auth/components/ConfirmLogout'
import { useAuth } from 'modules/Auth/hooks/useAuth'
import { usePermissions } from 'modules/Auth/hooks/usePermissions'

import LogoMain from 'shared/ui/App/LogoMain'
import { Button } from 'shared/ui/Button'
import Dropdown from 'shared/ui/Dropdown'
import Menu from 'shared/ui/Menu'

import { useAppSelector } from 'shared/config/redux/hooks/useRedux'
import { palette } from 'shared/config/styles/palette'

import { dashboardMenu } from '../../model/menu'

import './Sider.css'

const { Sider: _Sider } = Layout

const fullWidth = 280
const minWidth = 100

export type SiderProps = _SiderProps
export function Sider(props: SiderProps) {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { user } = useAppSelector((state) => state.auth)
  const { openModal } = useGlobalModal()
  const { handleLogout, isLogoutLoading } = useAuth()
  const { filterMenuByPermissions } = usePermissions()

  const [collapsed, setCollapsed] = useState<boolean>(true)

  const rootPath = useMemo(() => pathname.split('/')?.[2], [pathname])

  const selectHandler: MenuProps['onClick'] = (item) => {
    navigate(`/dashboard/${item.key}/`)
  }

  const toggleSider = () => {
    setCollapsed(!collapsed)
  }

  const handleMenuClick: MenuProps['onClick'] = async (e) => {
    if (user && e.key === 'logout') {
      openModal({
        body: (
          <ConfirmLogout
            onClick={handleLogout}
            isDisabled={isLogoutLoading}
          />
        ),
        withPadding: false,
      })
    }
  }

  return (
    <_Sider
      width={fullWidth}
      collapsedWidth={minWidth}
      collapsed={collapsed}
      trigger={null}
      collapsible
      theme="light"
      onCollapse={(value) => setCollapsed(value)}
      className="navWrapper z-10 flex-col gap-1"
      {...props}
    >
      <div
        className="fixed flex flex-col justify-between flex-1 h-lvh transition ease-in-out duration-[0.2s]"
        style={{ width: collapsed ? 100 : 280 }}
      >
        <div className="sticky top-0 overflow-y-auto">
          <div
            className={`flex gap-1 items-center ${collapsed ? 'pr-[16px]' : 'pr-[24px]'} pl-[20px] py-[16px] justify-between`}
          >
            <NavLink to="/dashboard/orders/">
              <LogoMain
                showOnlyLogo={collapsed}
                className="border-b-0 !px-[0px] !py-[0px] !w-auto cursor-pointer"
              />
            </NavLink>
            <Button
              onClick={toggleSider}
              className={`w-[20px] h-[20px] p-0 border-0 !bg-transparent ${collapsed ? 'rotate-180' : 'rotate-0'}`}
            >
              <Icon
                name="arrowBack"
                width={19}
                height={20}
                color={palette.dark}
              />
            </Button>
          </div>
          <Menu
            theme="light"
            defaultSelectedKeys={['1']}
            items={filterMenuByPermissions({
              menu: dashboardMenu,
            })}
            onClick={selectHandler}
            selectedKeys={[`${rootPath}`]}
            className="menuWrapper pb-[12px]"
          />
        </div>
        <div className="flex flex-col">
          <Dropdown
            menu={{
              items,
              onClick: handleMenuClick,
            }}
            trigger={['click']}
          >
            <Button className="h-fit flex items-center justify-between p-[8px] pr-[14px] mb-[16px] mx-[12px] !bg-light_gray_1 rounded-[10px] border-0">
              <div
                className={`flex gap-[8px] ${collapsed && 'justify-center flex-1'} items-center`}
              >
                <Icon
                  name="profile"
                  size={28}
                  color={palette.white}
                />
                {!collapsed && (
                  <span className="text-dark text-[13px] leading-[16px]">
                    {(user && user.first_name) || 'Нет имени'}
                  </span>
                )}
              </div>
              {!collapsed && (
                <Icon
                  name="burgerMenu"
                  width={4}
                  height={16}
                  color={palette.light_gray_4}
                />
              )}
            </Button>
          </Dropdown>
        </div>
      </div>
    </_Sider>
  )
}
